import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Livello_2"
    width={24}
    height={18}
    data-name="Livello 2"
    {...props}
  >
    <defs>
      <style>
        {
          ".cls-1{fill:none;stroke:#00a4b7;stroke-miterlimit:10;stroke-width:2px}"
        }
      </style>
    </defs>
    <g id="Palette">
      <path d="M0 1h24M0 9h24M0 17h24" className="cls-1" />
    </g>
  </svg>
)
export default SvgComponent
